import type { CanvaAuditEventDto } from "shared";

export function formatCanvaAuditEvent(event: CanvaAuditEventDto): string {
	const meta = event.metadata ?? {};
	switch (event.eventType) {
		case "canva.connected":
			return "Connected Canva account";
		case "canva.disconnected":
			return "Disconnected Canva account";
		case "canva.import.started": {
			const count = meta.count;
			const countLabel = typeof count === "number" ? String(count) : "?";
			return `Started import (${countLabel} design${count === 1 ? "" : "s"})`;
		}
		case "canva.import.completed": {
			const succeeded = typeof meta.succeeded === "number" ? meta.succeeded : 0;
			const failed = typeof meta.failed === "number" ? meta.failed : 0;
			if (failed > 0) {
				return `Import completed (${succeeded} succeeded, ${failed} failed)`;
			}
			return `Import completed (${succeeded} design${succeeded === 1 ? "" : "s"})`;
		}
		case "canva.sync.started":
			return "Sync started from Canva";
		default:
			return event.eventType.replace(/^canva\./, "").replaceAll(".", " ");
	}
}
